import styled from 'styled-components';
import { xs } from '../../../../BreakPoints';

export const Container = styled.div`
	display: flex;
	flex-direction: row;
	margin-left: 1rem;
	width: 100%;
	gap: 1rem;
	p {
    margin: 0.5px 0;
  }
`;

export const RightContainer = styled.div`
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	width: 100%;
	gap: 0.75rem;
`;

export const Title = styled.h3`
	margin: 0;
	padding: 0.2rem 0rem 0rem 0rem;
	display: inline;
	color: #172b4d;
	font-size: 1rem;
	font-weight: 800;
`;

export const DropdownContainer = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: flex-start;
	${xs({
		display: 'none',
	})}
`;